import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import MyInput from '../../components/forms/input'
import MyRichText from '../../components/forms/richText'
import MyImageUpload from '../../components/forms/imageUpload'

const EditEnthusiast = (props) => {
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  useEffect(() => {
    axios.post('/admin/content/enthusiast/detail/get', {
      enthusiast_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setFormValue(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [props.data])

  const handleOk = () => {
    setErrorMsg({})
    if (!formValue.title) {
      setErrorMsg({titleEmpty: '达人标题不能为空'})
      return false
    }
    if (!formValue.photo_url) {
      setErrorMsg({photoEmpty: '达人照片不能为空'})
      return false
    }
    if (!formValue.introduction) {
      setErrorMsg({introductionEmpty: '详细介绍不能为空'})
      return false
    }

    axios.post('/admin/content/enthusiast/edit', { 
      enthusiast_oid: formValue.oid,
      title: formValue.title,
      introduction: formValue.introduction,
      photo_url: formValue.photo_url,
      sort: Number(formValue.sort)
    })
      .then(function (response) {
        if (response.errcode === 0) {
          handleCancel()
          props.getEnthusiastData()
          message.success('修改成功！')
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleCancel = () => {
    setErrorMsg({})
    props.isCancel()
  }

  return (
    <Modal 
      title='编辑达人'
      destroyOnClose={true}
      width='800px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="取消"
      okText="保存">

      <MyInput
        id="title"
        required
        autoFocus
        maxLength={64}
        label='达人标题'
        placeholder='请输入达人标题'
        value={formValue.title}
        onChange={setFormValue}
        errorMsg={errorMsg.titleEmpty}
      />

      <MyImageUpload 
        id="photo_url"
        required
        label='达人照片'
        value={formValue.photo_url}
        setValue={setFormValue}
        errorMsg={errorMsg.photoEmpty}
      />

      <MyRichText
        id='introduction'
        required
        label='详细介绍'
        value={formValue.introduction}
        setValue={setFormValue}
        errorMsg={errorMsg.introductionEmpty}
      />

      <MyInput
        type='number'
        id="sort"
        label='排序'
        value={formValue.sort}
        onChange={setFormValue}
        styles={{ width: '60px' }}
        min={0}
        max={1000}
      />
    </Modal>
  )
}

export default EditEnthusiast
